import LeftRightContainer from './left-right-container'
import LeftSlider from './left-slider'
LeftRightContainer.install = function (Vue) {
  Vue.component(LeftRightContainer.name, LeftRightContainer)
}
LeftSlider.install = function (Vue) {
  Vue.component(LeftSlider.name, LeftSlider)
}
export { LeftRightContainer, LeftSlider }
